export default "assets/images/stars-4.5-abd15239.png";